(() => {
const ids = new Set([12643180871998,12643180904766,12643180937534,12643181297982,12643184640318,12643185787198,12643185819966,12643185852734,12643185885502,12643186016574,12643186147646,12643186213182,12643186245950,12643186999614,12643187982654,12644132520254,12644132880702,12644132979006,12644133044542,12644133208382,12644133372222,12644133404990,12644133634366,12644133699902,12644133798206,12644133896510,12644133962046,12644134060350,12644134158654,12644134191422,12644134420798,12644135305534,12644135567678,12644135665982,12644135764286,12644135829822]);
const root = window.Shopify?.routes?.root || '/';
let checking = false;
async function guard(event) {
 const checkout = event.type === 'click' ? event.target.closest('[name="checkout"],a[href*="/checkout"]') : event.submitter?.matches('[name="checkout"]');
 if (!checkout) return;
 event.preventDefault(); event.stopImmediatePropagation();
 if(checking) return; checking=true;
 try {
  const response=await fetch(root+'cart.js',{cache:'no-store'});
  if(!response.ok) throw new Error('cart');
  const cart=await response.json();
  const count=cart.items.reduce((n,item)=>n+(ids.has(item.product_id)?item.quantity:0),0);
  if(count>0&&count<10){
   const message='Para comprar mayoreo necesitas 10 piezas combinadas. Llevas '+count+' y te faltan '+(10-count)+'.';
   const notices=document.querySelectorAll('.hele-wholesale-notice');
   notices.forEach(n=>{n.textContent=message;});
   if(!notices.length) alert(message);
  }else{window.location.assign(root+'checkout');}
 }catch(error){alert('No pudimos verificar tu carrito. Intenta de nuevo antes de continuar al pago.');}
 finally{checking=false;}
}
document.addEventListener('click',guard,true);
document.addEventListener('submit',guard,true);
})();